import { useRoutes } from "react-router-dom";

import PublicRoutes from "./paths/PublicRoutes";
import AdminRoutes from "./paths/AdminRoutes";
import NotFoundRoutes from "./paths/NotFoundRoute";

import AccountRoutes from "./paths/AccountRoutes";
import DirectorRoutes from "./paths/DirectorRoutes";
import ProjectRoutes from "./paths/ProjectRoutes";
import QardAlHasanaRoutes from "./paths/QardAlHasanaRoutes";
import PersonRoutes from "./paths/PersonRoutes";
import InvestorRoutes from "./paths/InvestorRoutes";
import ExpenseRoutes from "./paths/ExpenseRoutes";
import StaffRoutes from "./paths/StaffRoutes";
import CuttingRoutes from "./paths/CuttingRoutes";
import TradersRoutes from "./paths/TradersRoutes";
import InvestmentRoutes from "./paths/InvestmentRoutes";
import AdvanceRoutes from "./paths/AdvanceRoutes";
import LoanRoutes from "./paths/LoanRoutes";
import DpsRoutes from "./paths/DpsRoutes";
import OthersIncomeRoutes from "./paths/OthersIncome";
import SMSRoutes from "./paths/SMSRoutes";

export default function Routes() {
  return useRoutes([
    PublicRoutes,
    AccountRoutes,
    DirectorRoutes,
    ProjectRoutes,
    QardAlHasanaRoutes,
    PersonRoutes,
    InvestorRoutes,
    ExpenseRoutes,
    StaffRoutes,
    CuttingRoutes,
    TradersRoutes,
    InvestmentRoutes,
    AdvanceRoutes,
    LoanRoutes,
    DpsRoutes,
    AdminRoutes,
    NotFoundRoutes,
    OthersIncomeRoutes,
    SMSRoutes,
  ]);
}
